import { IconButton } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import Model from '../models/model';
import strings from "../Globalization/index";
import util from '../util/index';

const { viewOnly } = util;

const UseCountEndAdornment = ({ formik }) => {
	return (
		<IconButton color="success" size="small" onClick={
			() => {
				formik.setFieldValue('UseCount', 0);
			}
		}>
			<AutorenewIcon />
		</IconButton>
	);
};
const model = new Model({
	name: 'ReusableTestPack',
	gridTitle: 'ReusableTestPack',
	defaultSort: 'ReusableTestPackName',
	formTitleField: 'Name',
	readOnly: viewOnly,
	disableAdd: viewOnly,
	disableExport: viewOnly,
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true
	},
	columns: [
		{ header: 'UniqueId', field: 'ReusableTestPackId', keyColumn: true, hidden: true, width: 120 },
		{
			header: 'TestPackName',
			field: 'ReusableTestPackName',
			width: 150,
			maxLength: 50,
			required: true,
			customizeInput: ({ Input, inputProps }) => {
				inputProps.fieldLabel = 'Test Pack Name'
				return (
					<Input {...inputProps} />
				)
			}
		},
		{
			header: 'ModalName', field: 'ModelName', width: 200, required: true, customizeInput: ({ Input, inputProps }) => {
				inputProps.fieldLabel = 'Model Name'
				return (
					<Input {...inputProps} />
				)
			}
		},
		{
			header: 'MaximumUses',
			field: 'MaxUses',
			width: 150,
			type: 'number',
			required: true,
			align: 'right',
			customizeInput: ({ Input, inputProps }) => {
				inputProps.fieldLabel = "Maximum Number of Uses"
				inputProps?.formik?.values.MaxUses < 0 && inputProps.formik.setFieldValue('MaxUses', 0)
				return (
					<Input {...inputProps} />
				)
			}
		},
		{
			header: 'UseCount',
			field: 'UseCount',
			width: 120,
			readOnly: true,
			type: 'number',
			align: 'right',
			customizeInput: ({ Input, inputProps }) => {
				inputProps?.formik?.values.UseCount < 0 && inputProps.formik.setFieldValue('UseCount', 0)
				return <Input
					{...inputProps}
					otherProps={{
						...inputProps.otherProps,

						InputProps: {
							endAdornment: <UseCountEndAdornment formik={inputProps.formik} />
						}
					}}
				/>
			}
		},
		{
			header: 'EquipmentType', field: 'EquipmentType', width: 250, formField: 'EquipmentTypeId', lookup: 'EquipmentType', required: true, parseFilterValue: (newValue) => {
				return Array.isArray(newValue) ? newValue.map((entry) => entry.label) : newValue?.label;
			}
		},
		{ header: 'Active', field: 'IsActive', width: 120, type: 'bool' }
	]
});

export default model.createFormBase();